import { resourceMariPing } from '../../api/resources';
import store from '../../store';
import { getCookie } from '../../cookies';
import { SESSION_ID_COOKIE, USER_TYPES } from '../../constants';

const PING_INTERVAL_SEC = 60;
let intervalId = null;

/**
 * What needs to execute in some time
 * @param callback
 */
let executor = callback => {
    if (getCookie(SESSION_ID_COOKIE)) {
        if (store.state.user.user.type === USER_TYPES.SUPER_USER) {
            resourceMariPing({
                method: 'post',
                data: JSON.stringify({
                    session_id: getCookie(SESSION_ID_COOKIE),
                }),
            }).catch(() => {
                callback.timeoutCallback(callback.setNotification);
            });
        }
    }
};

const ping = {
    bind(el, binding) {
        return (intervalId = setInterval(executor.bind(null, binding.value), PING_INTERVAL_SEC * 1000));
    },
    unbind() {
        clearInterval(intervalId);
    },
};

export default ping;
